import { createFileRoute, Link, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { RedirectIfAuthed } from "@/components/RedirectIfAuthed";
import { Shell } from "@/components/Shell";
import { Button, Card, ErrorBanner, Field, Input, PasswordInput } from "@/components/ui-kit";
import { useAuth } from "@/lib/auth";

export const Route = createFileRoute("/login")({
  component: LoginPage,
});

function LoginPage() {
  const { loginBorrower, session, initializing } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (initializing || session) {
    return (
      <Shell>
        <RedirectIfAuthed />
      </Shell>
    );
  }

  const submit = async () => {
    setError(null);
    if (!email || !password) return setError("Email and password are required.");
    setLoading(true);
    try {
      const kind = await loginBorrower(email, password);
      nav({ to: kind === "admin" ? "/admin" : "/borrower" });
    } catch (e) {
      setError(e instanceof Error ? e.message : "Login failed.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Shell>
      <div className="mx-auto max-w-md px-6 py-16">
        <Card>
          <h1 className="font-display text-3xl">Welcome back</h1>
          <p className="text-sm text-muted-foreground mt-1">Sign in to your CrediKing portal.</p>

          <div className="mt-6 space-y-4">
            <ErrorBanner message={error} />
            <Field label="Email">
              <Input type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com" />
            </Field>
            <Field label="Password">
              <PasswordInput autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" />
            </Field>
            <div className="flex justify-end -mt-2">
              <Link to="/forgot-password" className="text-xs text-gold hover:underline">
                Forgot password?
              </Link>
            </div>
            <Button variant="gold" loading={loading} onClick={submit} className="w-full">
              Sign in
            </Button>
            <p className="text-sm text-center text-muted-foreground">
              No account?{" "}
              <Link to="/signup" className="text-gold hover:underline">Request access</Link>
            </p>
            <p className="pt-1 text-sm text-center">
              <a href="/" className="text-gold hover:underline">← Home</a>
            </p>
          </div>

        </Card>
      </div>
    </Shell>
  );
}
